<template>
  <div id="fileUploadComponent">
    <div class="d-flex flex-column">
      <!-- Menu Header -->
      <div class="d-flex align-items-center justify-content-around w-100">
        
        <!-- Sección izquierda -->
        <div class="d-flex align-items-center w-75">

            <!-- Btn Adjuntar documento -->
            <label for="file" style="margin: 0 !important">
                <button-component
                    :text="text"
                    :size="18"
                    colorText="#ffffff"
                    :color="urlFile ? '#146ebe' : '#696969'"
                    tooltip="Subir archivo"
                    icon="far fa-folder-open"
                    :width="width"
                    :height="height"
                    :horizontal="horizontal"
                />
            </label>
            
            <!-- Input file -->
            <input id="file" class="w-100 ml-2" type="file" name="file" @change="reemplazarArchivo" 
                accept="application/xls, application/xlsx, application/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" />

            <!-- Información de archivos seleccionado -->
            <div class="d-flex" v-if="nombreArchivo.length">
                <div class="d-flex ml-2" v-if="nombreArchivo.length">{{ nombreArchivo }}
                    <div class="pesoFile ml-2" :style="{ background: colorIconInputFile }" >{{pesoArchivo}}</div>
                </div>
            </div>

        </div>

        <!-- Sección derecha -->
        <div class="d-flex align-items-center justify-content-end mr-1 w-25">
          <!-- Btn Eliminar archivo -->
          <button-component
            v-if="urlFile ? true : false"
            :size="15"
            colorText="#ffffff"
            color="#de2c2c"
            tooltip="Eliminar archivo"
            icon="far fa-trash-alt"
            round
            :width="30"
            class="ml-1"
            @click.native="limpiarCarga()"
          />

          <!-- Btn Subir archivo -->
          <button-component
            v-if="urlFile ? true : false"
            :size="15"
            colorText="#ffffff"
            color="#2da44e"
            tooltip="Subir planificación"
            icon="icon fas fa-check"
            round
            :width="30"
            class="ml-1"
            @click.native="!uploadFileLoading ? subirArchivo(fileUploadModel) : ''"
            :inactive="uploadFileLoading ? true : false"
          />
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
// Vue
import Vue from "vue";

// Vuex
import { mapActions, mapState } from "vuex";

// Toast
import VueToastify from "vue-toastify";
Vue.use(VueToastify);

// Componentes
import Button from "./Button";

// icon Excel
import ExcelIcon from "../../assets/img/icons/excel_icon.svg";

export default {
  props: {
    constant: {
      type: Function,
      default: function () {
        return {};
      },
    },
    horizontal: Boolean,
    select_file_data: { type: Array || Object },
    text : { Type: String, default:""},
    height: { Type: String, default:"10px"},
    width: { Type: String, default:"10px"},
  },

  computed: {
    ...mapState([
      "uploadFileLoading",
      "uploadFileLoadingError",
    ]),
  },

  data() {
    return {
      fileUploadModel: {},
      fileSelectedModel: {},
      urlFile: "",
      formatosPermitidos: "",
      tipoArchivo: "",
      iconIputFile: "far fa-folder-open",
      colorIconInputFile: "",
      nombreArchivo: "",
      pesoArchivo: "",
      dataExcel: "",
      excelIcon: ExcelIcon,
      idFileSelected: "",
      toastityText: {
        titulo: "Subiendo archivo",
        textoSecundario: "Archivo subido con exito",
      },
    };
  },

  components: {
    "button-component": Button,
  },

  methods: {

    ...mapActions('lineas',["actionSetDataPlanificacionAnualTabla"]),

    openModal(ref) {
      this.$refs[ref].open();
      this.limpiarCarga();
    },

    closeModal(ref) {
      this.$refs[ref].close();
      this.limpiarCarga();
    },

    reemplazarArchivo(file) {

        // Nombre
        let fileAux = file.target.files[0];

        // Verifica la extensión del archivo
        let newURL           = URL.createObjectURL(fileAux);
        this.fileUploadModel = fileAux;
        this.urlFile         = newURL;

        // Si el archivo es tipo excel
        fileAux.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        this.obtenerNombreYpeso(fileAux);

    },

    limpiarCarga() {

      this.urlFile           = "";
      this.fileUploadModel   = {};
      this.tipoArchivo       = "";
      this.fileSelectedModel = "";
      this.nombreArchivo     = "";
      this.pesoArchivo       = ""

    },

    async subirArchivo(file) {
      await this.constant(file);
    },

    obtenerNombreYpeso(file) {
      // Valor inicial en bytes
      let size = Math.round(file.size / 1024); // Valor en bytes
      let unidadPeso = "KB";

      this.iconIputFile = "far fa-file-excel";
      this.colorIconInputFile = "#056c1c";

      // Si el archivo es superior a 1000 bytes se debe transformar el peso a megabytes
      if (size > 1000) {
        size = Math.round(size / 1024, 1);
        unidadPeso = "MB";
      }

      // Nombre de archivo
      let nombreSplit = file.name.split(".");

      let nombreArchivo = "";

      for (let i = 0; i < nombreSplit.length - 1; i++) {
        i == 0
          ? (nombreArchivo += nombreSplit[i])
          : (nombreArchivo += " " + nombreSplit[i]);
      }

      this.nombreArchivo = nombreArchivo;
      this.pesoArchivo = size + unidadPeso;
    },

  },

  created() {
    this.limpiarCarga();
  },

  watch: {

    uploadFileLoading: function (_new) {

      if (!_new) {

        if(!this.uploadFileLoadingError.estado){

          this.limpiarCarga();
          
          this.actionSetDataPlanificacionAnualTabla();

          this.$vToastify.success( this.toastityText.textoSecundario, "Proceso finalizado");
        
        }else{

          this.$vToastify.error( this.uploadFileLoadingError.message, "Proceso finalizado");

        }

      }

    },

    select_file_data: function (_new) {
      _new ? (this.selectFileData = _new) : "";
    },

  },
};
</script>

<style>
#fileUploadComponent .ui-modal:not(.has-footer) .ui-modal__body {
  padding: 0.5rem 0.5rem 0.5rem;
}

.ui-modal__container {
  width: 70rem !important;
}

input[type="file"] {
  display: none;
}

.pesoFile {
  color: #fff;
  padding: 0 5px;
  border-radius: 5px;
  font-size: 9px;
  line-height: 2.3;
  font-weight: 700;
}

</style>
